var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"masthead",class:("masthead--" + (_vm.$site.prefix)),attrs:{"src":_vm.mastheadSrc,"alt":_vm.theSiteName}})}
var staticRenderFns = []

export { render, staticRenderFns }